import * as React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useQuickFiltersContext } from 'modules/expenses/components/expenses/PageContents/QuickFiltersContext'
import { MyGroupedExpensesDataCollection } from 'modules/expenses/components/my_groups/expenses/DataCollection/MyGroupedExpensesDataCollection'
import { MyGroupedExpensesDataTable } from 'modules/expenses/components/my_groups/expenses/Datatable'
import { useExpensesListPage } from 'modules/expenses/hooks/useExpensesListPage'
import { Group } from 'modules/expenses/hooks/useGroup'
import { useMyExpenses } from 'modules/expenses/pages/my_expenses/MyExpensesContext'

export interface ListProps {
  group: Group
  back: { href: string }
}

const ExpensesList = ({ group, back }: React.PropsWithChildren<ListProps>) => {
  const { filters } = useQuickFiltersContext()
  const { company } = useCurrentSession()

  const {
    data,
    featureAvailabilities: { dataCollectionEnabled },
  } = useMyExpenses()

  const {
    categories,
    subcategories,
    currencies,
    canSeeTransactions,
    hasExpensesReportOnBehalfFeature,
    canUsePerDiems,
    loading,
  } = useExpensesListPage({ companyId: company.id, skipProjectsQuery: true })

  // My Expenses doesn't support payroll reimbursement - use defaults
  // TODO: Remove when we will fully migrate to DataCollection
  const availableCategories: string[] = []
  const currentPeriodOpen = false

  if (loading) {
    return (
      <Box paddingY="s32" paddingX="s48" justifyContent="center" alignItems="center" width="full">
        <Spinner />
      </Box>
    )
  }

  return dataCollectionEnabled ? (
    <MyGroupedExpensesDataCollection
      group={group}
      companyId={company.id}
      canSeeTransactions={canSeeTransactions}
      hasReportOnBehalfFeature={hasExpensesReportOnBehalfFeature}
    />
  ) : (
    <MyGroupedExpensesDataTable
      key={JSON.stringify(filters)} //re-mount the datatable if expensable search params change
      group={group}
      subcategories={subcategories}
      currencies={currencies}
      currentPayrollPeriodOpen={currentPeriodOpen}
      availablePayrollCategories={availableCategories || []}
      categories={categories}
      back={back}
      hasReportOnBehalfFeature={hasExpensesReportOnBehalfFeature}
      canSeeTransactions={canSeeTransactions}
      canCreateExpensesForOthers={data.expenses._policies.expenseCreateExpensesForOthers.can}
      canCreateExpenses={data.expenses._policies.expenseCreateExpenses.can}
      canUsePerDiems={canUsePerDiems}
    />
  )
}

export default observer(ExpensesList)
